import React from "react";
import Chart from "react-apexcharts";

const EmployeeStatsPieCharts = ({ employeeStats }) => {
  if (!employeeStats || employeeStats.length === 0) {
    return <p className="text-gray-400">No employee data available</p>;
  }

  const labels = employeeStats.map((e) => e.fullName || "Unknown");
  const earningsData = employeeStats.map((e) => e.earnings || 0);
  const bookingsData = employeeStats.map((e) => e.bookingsCount || 0);

  const earningsOptions = {
    chart: { type: "pie", id: "employee-earnings-pie" },
    labels,
    legend: { position: "bottom", labels: { colors: "#FFFFFF" } },
    dataLabels: { enabled: true },
    tooltip: { y: { formatter: (val) => `₹${val}` } },
  };

  const bookingsOptions = {
    chart: { type: "pie", id: "employee-bookings-pie" },
    labels,
    legend: { position: "bottom", labels: { colors: "#FFFFFF" } },
    dataLabels: { enabled: true },
    tooltip: { y: { formatter: (val) => `${val} bookings` } },
  };

  return (
    <div className="flex flex-col md:flex-row gap-6 w-full">
      <div className="flex-1 bg-[#151515] p-6 rounded-xl border border-[#2b2b2b]">
        <h4 className="text-white text-lg font-bold mb-4 text-center">Earnings Share</h4>
        <div className="flex justify-center">
          <Chart options={earningsOptions} series={earningsData} type="pie" width="100%" />
        </div>
      </div>
      <div className="flex-1 bg-[#151515] p-6 rounded-xl border border-[#2b2b2b]">
        <h4 className="text-white text-lg font-bold mb-4 text-center">Bookings Share</h4>
        <div className="flex justify-center">
          <Chart options={bookingsOptions} series={bookingsData} type="pie" width="100%" />
        </div>
      </div>
    </div>
  );
};

export default EmployeeStatsPieCharts;
